import React from "react";
import { Text } from "@components/formx";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  name: string;
  label: string;
  width?: string;
  disabled?: boolean;
};

export function OutlinedInput(props: Props) {
  const { width = "10rem" } = props;

  const classes = useStyles({});

  return (
    <Text
      name={props.name}
      label={props.label}
      TextFieldProps={{
        fullWidth: false,
        style: { width },
        variant: "outlined" as any,
        InputLabelProps: {
          classes: { outlined: classes.label }
        },
        InputProps: {
          disabled: props.disabled,
          classes: { input: classes.input }
        }
      }}
    />
  );
}

const useStyles = makeStyles(() => ({
  label: {
    transform: "translate(14px, 14px) scale(1)"
  },

  input: {
    padding: "10px 14px"
  }
}));
